<template>
  <div>
    <SpFilterForm :model="formData" @onSearch="onSearch" @onReset="onReset">
      <SpFilterFormItem prop="tcb_order_no">
        <el-input v-model="formData.tcb_order_no" placeholder="请输入订单号" />
      </SpFilterFormItem>
      <SpFilterFormItem prop="marketing_time">
        <el-date-picker class="form-item__content custom-date-picker" v-model="marketing_time" start-placeholder="创建开始日期" end-placeholder="创建结束日期" type="daterange"
          range-separator="至" format="yyyy 年 MM 月 dd 日" value-format="yyyy-MM-dd" />
      </SpFilterFormItem>
      <SpFilterFormItem prop="tcb_order_no">
        <el-button type="primary" @click="exportData">导出订单</el-button>
      </SpFilterFormItem>
    </SpFilterForm>

    <el-tabs v-model="formData.order_status" @tab-click="handleClick">
      <el-tab-pane v-for="item in tabsList" :key="item.name" :label="item.label" :name="item.name"></el-tab-pane>
    </el-tabs>

    <SpFinder no-selection ref="finder" :setting="setting" row-actions-width="200" :row-actions-align="'left'"
      :fixed-row-action="true" :url="url" :split-count="4" :hooks="{ beforeSearch: beforeSearch }" />

  </div>
</template>

<script>
const ORDER_STATUS = {
  'completed': {
    label: '已成交',
    name: '10'
  },
  'cancelled': {
    label: '已取消',
    name: '99'
  }
}

import Vue from 'vue'
import { createSetting, useDialog } from '@shopex/finder'
import { exportOldPhoneRecycle, url } from './api'

export default {
  data() {
    return {
      tabsList: [
        {
          label: '全部',
          name: ''
        },
        ...Object.values(ORDER_STATUS)
      ],
      formData: {
        tcb_order_no: '',
        order_status: '',
        start_time: '',
        end_time: '',
      },
      marketing_time: [],
      exportParams: {}
    }
  },
  computed: {
    url() {
      return url
    },
    setting() {
      return createSetting({
        columns: [
          {
            name: '订单号',
            key: 'tcb_order_no',
          },
          {
            name: '订单状态',
            key: 'order_status_text',
          },
          {
            name: '旧机品牌',
            key: 'brand_name',
          },
          {
            name: '旧机型号',
            key: 'model_name',
          },
          {
            name: '检测价格',
            key: 'eval_price',
          },
          {
            name: '成交价格',
            key: 'final_price',
            // render: (h, { row }) => {
            //   return (
            //     <div style='color: #176721;'>{row.deal_price}</div>
            //   )
            // }
          },
          {
            name: 'IMEI号',
            key: 'imei',
          },
          {
            name: '回收时间',
            key: 'complete_time',
          },
          {
            name: '订单创建时间',
            key: 'order_create_time',
          },
          {
            name: '订单取消时间',
            key: 'order_cancel_time',
          },
          {
            name: '旧机详情',
            key: '',
            render: (h, { row }) => {
              return (
                <div>
                  <el-popover
                    placement="top-start"
                    title="旧机详情"
                    width="200"
                    trigger="hover"
                    content={ row.assess_title }>
                    <el-button slot="reference">查看</el-button>
                  </el-popover>
                </div>
              )
            }
          }
        ]
      })
    },
  },
  methods: {
    onSearch() {
      this.$refs.finder.refresh(true)
    },
    onReset() {
      this.formData = {
        tcb_order_no: '',
        order_status: '',
        start_time: '',
        end_time: '',
      }
      this.marketing_time = []
      this.onSearch()
    },
    beforeSearch(param) {
      let params = {
        ...this.formData,
        ...param,
        page_size: param.pageSize
      }

      // 将 marketing_time 数组拆分为 start_time 和 end_time，并将毫秒转换为秒
      if (this.marketing_time && this.marketing_time.length === 2) {
        params.start_time = this.marketing_time[0]
        params.end_time = this.marketing_time[1]
      }

      this.exportParams = params
      return params
    },
    handleClick(tab, event) {
      this.onSearch()
    },
    exportData() {
      exportOldPhoneRecycle({ ...this.exportParams, is_export: 1 }).then(res => {
        if (res.data.data.success) {
          this.$message({
            type: 'success',
            message: '已加入执行队列，请在设置-导出列表中下载'
          })
        }
        console.log(res)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.form-item__content {
  :deep(.el-range-input) {
    width: 100px !important;
  }
}
</style>

